import { InfoIcon } from "lucide-react";
import type { ReactNode } from "react";
import { Focusable, TooltipTrigger } from "react-aria-components";
import { twMerge } from "tailwind-merge";

import { Tooltip } from "./tooltip";

export function Information({
  triggerClassName,
  children,
}: {
  triggerClassName?: string;
  children: ReactNode;
}) {
  return (
    <TooltipTrigger delay={100} closeDelay={50}>
      <Focusable>
        <span className={twMerge("flex", triggerClassName)}>
          <InfoIcon className="inline" size={16} />
        </span>
      </Focusable>

      <Tooltip className="bg-white">
        <div className="max-w-48">{children}</div>
      </Tooltip>
    </TooltipTrigger>
  );
}
